import { Link } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="relative pt-20 min-h-[80vh] flex items-center">
      <div className="absolute inset-0 grid-pattern-fine" />
      <div className="absolute inset-0 noise-texture" />
      
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative z-10 w-full">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-caption mb-4">Error 404</p>
          <h1 className="text-display text-foreground mb-6">
            Page Not Found
          </h1>
          <p className="text-subtitle mb-10">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className="btn-primary">
              <Home className="h-4 w-4 mr-2" />
              Back to Home
            </Link>
            <Link to="/contact" className="btn-secondary">
              Contact Us
              <ArrowRight className="h-4 w-4 ml-2" />
            </Link>
          </div>
          
          <div className="mt-16">
            <p className="text-body mb-4">Looking for something specific?</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/defence" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Defence Platforms
              </Link>
              <span className="text-muted-foreground/30">•</span>
              <Link to="/technologies" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Technologies
              </Link>
              <span className="text-muted-foreground/30">•</span>
              <Link to="/defence/ai-av" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                AI-AV Platform
              </Link>
              <span className="text-muted-foreground/30">•</span>
              <Link to="/our-companies" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                Our Companies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
